import React from "react";
import BarraSupDent from "../../commons/NavUp";
import Title from "../Login/Components/title/title";
import "./Price_estimate.css";
import firebaseManager from '../../model/Firebase/FirebaseManager'

class Price_estimate extends React.Component {
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        ele.classList.add("available");
        setTimeout(() => {
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }
  constructor() {
      super()
      this.getDataDent = this.getDataDent.bind(this)
      this.state = {
          price: ''
      }
      this.getDataDent()
  }

  getDataDent() {
      firebaseManager.dentInProgress(this.successData)
  }

  successData = (data) => {
    this.setState({
        price: data.price
    })
  }

  confirmDent = () => {
    firebaseManager.confirmDent(this.successConfirm, this.failConfirm);
  };

  successConfirm = () => {
    window.location = "/home";
  };

  failConfirm(error) {
    alert(error.mesagge);
  }

  rejetDent = () => {
    firebaseManager.rejectDent(this.rejectedCallback);
  };

  rejectedCallback = () => {
    window.location="/home";
  };

  render() {
    return (
      <React.Fragment>
        <BarraSupDent />
        <Title text1="Your estimated repair cost is:" />
        <div className="mx-auto box_price mt-5">
          <span className="d-block pt-3 text-center size_price">${this.state.price}</span>
        </div>
        <div className="m-auto box_message">
          <p className="text-center mt-5">
            Once you confirm the price, we will book you an appointment with an
            available Dent Specialist.
          </p>
        </div>
        <div className="text-center mt-5">
            <button onClick={this.confirmDent} className="btn btn-secondary mt-3">Confirm price</button>
        </div>
        <div className="text-center mt-3 mb-5">
            <button onClick={this.rejetDent} className="btn_no_thanks mb-5">No, thanks</button>
        </div>
      </React.Fragment>
    );
  }
}

export default Price_estimate;
